// Toggles between the Add to Cart button and whatever sits behind it when a product's sold out
// - the "this product will not be restocked" message for exit-tagged products (see
// snippets/back-in-stock-trigger.liquid), or a manually-placed Klaviyo Back in Stock trigger
// for every other product - live on the theme's native "variant:change" event, for both the
// native buy box (buy-buttons.liquid) and the volume/bundle selector widget.
(function () {
  document.addEventListener('variant:change', (event) => {
    const formId = event.target.getAttribute('id');
    if (!formId) return;

    // buy-buttons.liquid's wrapper carries form="{formId}"; the volume selector's own form
    // simply *is* that id (see CUSTOMIZATIONS.md's volume-selector formId-shadowing fix).
    document.querySelectorAll(`buy-buttons[form="${formId}"], .volume-selector[data-product-form-id="${formId}"]`).forEach((container) => {
      const addToCart = container.querySelector('.buy-buttons__add-to-cart, .volume-selector__add-to-cart');
      const backInStock = container.querySelector('.buy-buttons__back-in-stock, .volume-selector__back-in-stock');
      if (!addToCart || !backInStock) return;

      try {
        addToCart.hidden = !event.detail.variant.available;
        backInStock.hidden = event.detail.variant.available;
      } catch (error) {
        console.error('back-in-stock: failed to update trigger', error);
      }
    });
  });
})();
